import moment from 'moment';

// Types
import {
  ACCOUNT_SUMMARY_REQUEST_START,
  ACCOUNT_SUMMARY_REQUEST_FAIL,
  ACCOUNT_SUMMARY_REQUEST_SUCCESS,
  ACCOUNT_COMMISSIONS_PENDING,
  ACCOUNT_COMMISSIONS_FAIL,
  ACCOUNT_COMMISSIONS_SUCCESS,
  ACCOUNT_COMMISSIONS_DATA_RESET
} from './types';
// Redux
import { AccountSummaryAction } from './actions';

type AccountSummaryState = {
  loadingState: string,
  graphDataLoadingState: string,
  results: any,
  resultsComm: any
};

// Initial date
const date = moment();
let paymentDate = moment().date(5); // 5th of the month

const getMonths = () => {
  const table: any = [];
  // const date = moment();
  const start = moment().startOf('month')
  for (let i = 0; i < 12; i++) {
    start.subtract(1, 'month')
    const month = start.format('MMMM');
    const period = start.format('MMMM YYYY');

    table[i] = {
      event: {
        eventStart: period,
        eventEnd: month,
        eventLabel: period,
        eventLabelSmall: ''
      },
      fields: [
        {
          fieldName: 'Referrals',
          fieldLabel: 'Referrals',
          fieldValue: 0,
          fieldType: 'number'
        },
        {
          fieldName: 'Registrations',
          fieldLabel: 'Registrations',
          fieldValue: 0,
          fieldType: 'number'
        },
        {
          fieldName: 'Traded Accounts',
          fieldLabel: 'Traded Accounts',
          fieldValue: 0,
          fieldType: 'number'
        },
        {
          fieldName: 'Commissions',
          fieldLabel: 'Commissions',
          fieldValue: 0,
          fieldType: 'currency',
          customAttributes: {
            currency: '£',
            paid: true
          }
        }
      ],
      order: date.month()
    }
  }

  return table;
}

const INITIAL_STATE: AccountSummaryState = {
  loadingState: 'UNINITIALISED',
  graphDataLoadingState: 'UNINITIALISED',
  results: {
    summaries: {
      referrals: 0,
      registrations: 0,
      accounts: 0,
    },
    table: getMonths()
  },
  resultsComm: {
    commissions: {
      balance: 0,
      date: (date > paymentDate) ? paymentDate.add(1, 'M') : paymentDate,
      generatedMonthly: 0,
      generatedQuarterly: 0,
      generatedMonthlyChange: '0.00 (0.00%)',
      generatedQuarterlyChange: '0.00 (0.00%)',
      paidMonthly: 0,
      paidQuarterly: 0,
      paidMonthlyChange: '0.00 (0.00%)',
      paidQuarterlyChange: '0.00 (0.00%)',
    }
  }
};

export const reducer = (
  state = INITIAL_STATE,
  action: AccountSummaryAction
): AccountSummaryState => {
  switch (action.type) {
    case ACCOUNT_SUMMARY_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING',
      };

    case ACCOUNT_SUMMARY_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        results: action.payload
      };

    case ACCOUNT_SUMMARY_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR',
      };

    // Commissions START
    case ACCOUNT_COMMISSIONS_PENDING:
      return {
        ...state,
        graphDataLoadingState: 'ACCOUNT_COMMISSIONS_LOADING',
      };

    case ACCOUNT_COMMISSIONS_SUCCESS:
      return {
        ...state,
        graphDataLoadingState: 'ACCOUNT_COMMISSIONS_LOADED',
        resultsComm: action.payload
      };

    case ACCOUNT_COMMISSIONS_FAIL:
      return {
        ...state,
        graphDataLoadingState: 'ACCOUNT_COMMISSIONS_ERROR',
      };

    case ACCOUNT_COMMISSIONS_DATA_RESET:
      return {
        ...state,
        resultsComm: null,
        loadingState: 'LOADED'
      }

    default:
      return state;
  }
};